import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import FormTestDrive from "../testdrive/FormTestDrive";
const Footer = lazy(() => import('../footer/Footer'));
function TestDrive(props) {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai te apoyamos. Revisa todos los modelos que tenemos para ti de acuerdo a tus necesidades. Puedes cotizar en línea"
        />
        <meta
          name="keywords"
          content="Hyundai, Grand i10, Accent, Ioniq, Creta, Tucson, Santa Fe"
        />
        <title>Cotiza tu Hyundai</title>
      </Helmet>
      <Menu />
      <FormTestDrive datos={props} />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default TestDrive;